import BlobIcon, {
    BlobIconTypes,
} from '@ilg-totallymoney/ui/components/BlobIcon'
import Box from '@ilg-totallymoney/ui/components/Box'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Row from '@ilg-totallymoney/ui/components/Row'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import theme from '@ilg-totallymoney/ui/theme'

import useAppQueryState from '@hooks/useAppQueryState'

import { creditCardBenefits } from './lib/creditCardBenefits'
import { creditCardInformation } from './lib/creditCardInformation'

const createBenefitsList: Record<number, BlobIconTypes> = {
    0: 'money',
    1: 'thumbsUp',
    2: 'celebrate',
    3: 'otherAccounts',
}

const AboutSection = () => {
    const { appQueryState } = useAppQueryState()
    const category = appQueryState.categoryId!

    return (
        <Box gridColumn="1/13">
            <Box
                display="grid"
                gridTemplateColumns={['1fr', 'repeat(2, 1fr)']}
                gridGap={['space30', 'space30', 'space50']}
            >
                <Stack space="space15">
                    {creditCardBenefits[category]?.map((benefit, i) => (
                        <Row
                            key={`${benefit}-${i}`}
                            space="space20"
                            p="space15"
                            backgroundColor={theme.indigo10}
                            borderRadius="borderRadius20"
                            alignItems="center"
                            width="100%"
                        >
                            <Box aria-hidden>
                                <BlobIcon
                                    blobName={createBenefitsList[i]}
                                    size={40}
                                />
                            </Box>

                            <Box>
                                <Heading variant="20">{benefit}</Heading>
                            </Box>
                        </Row>
                    ))}
                </Stack>

                {creditCardInformation[category]}
            </Box>
        </Box>
    )
}

export default AboutSection
